// extracted by mini-css-extract-plugin
export default {"wrapper":"AlphaModalTheme_wrapper__rbopX","btn":"AlphaModalTheme_btn__WqnK-"};